<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <app-modal-back></app-modal-back>
    </ion-buttons>
    <ion-title>{{ isNewAgreement ? 'Offer a new' : 'Update' }} agreement</ion-title>
  </ion-toolbar>
  <ion-progress-bar
    type="indeterminate"
    *ngIf="loaderService.isLoadingInProgress"
  ></ion-progress-bar>
</ion-header>

<ion-content
  *ngIf="form"
  data-testid="agreement-form-step3"
>
  <div class="ion-margin-top ion-margin-horizontal">
    <app-agreement-status-chip [agreementStatus]="agreement.status"></app-agreement-status-chip>
  </div>
  <ion-item
    lines="none"
    class="default listItem"
  >
    <user-avatar-gql
      [avatar]="agreement?.otherUser?.avatar"
      [name]="agreement?.otherUser?.displayName"
      avatarSize="small"
    >
    </user-avatar-gql>
    <ion-label>
      <h2 class="large">{{ agreement?.otherUser?.displayName }}</h2>
      <p class="ion-color-grey-500">{{ agreement?.otherUser?.profile?.typeOfCare }}</p>
    </ion-label>
  </ion-item>
  <div
    *ngIf="agreement"
    class="mable-section ion-margin-vertical"
  >
    <!-- RATES FORM -->
    <app-agreement-rates-form
      [agreement]="agreement"
      [workerProfile]="profileObject"
      [hasSubmitted]="hasSubmitted"
      [budgetSupportTypes]="budgetSupportTypes"
      [shouldShowBudgetSupportTypeInformation]="shouldShowBudgetSupportTypeInformation"
      [minimumRate]="minimumRate"
      (valueChange)="onRatesChange($event)"
    ></app-agreement-rates-form>

    <!-- TRAVEL RATE FORM -->
    <app-agreement-travel-form
      class="ion-padding-top"
      [agreement]="agreement"
      (valueChange)="onTravelRateChange($event)"
    ></app-agreement-travel-form>

    <!-- NEED MORE HELP -->
    <app-agreement-need-more-help-form
      *ngIf="organisationTerms?.organisationName && isPrivateJob"
      [otherUser]="agreement?.otherUser"
      [organisationName]="organisationTerms?.organisationName"
      [isHeadingSectionVisible]="false"
    ></app-agreement-need-more-help-form>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar *ngIf="!isPrivateJob">
    <mable-button
      size="large"
      expand="block"
      buttonType="submit"
      [throttleTime]="1000"
      (onClick)="onNext()"
      ariaLabel="Proceed to next step 4"
      data-testid="agreement-form-step3-next-button"
    >
      Next
    </mable-button>
  </ion-toolbar>
  <ion-toolbar *ngIf="isPrivateJob">
    <ion-grid>
      <ion-row>
        <ion-col>
          <mable-button
            class="ion-no-margin"
            category="outline"
            expand="block"
            (onClick)="closeModal()"
            data-testid="agreement-form-step3-cancel-button"
            >Cancel
          </mable-button>
        </ion-col>
        <ion-col>
          <mable-button
            class="ion-no-margin"
            expand="block"
            category="orange-500"
            (onClick)="submitRequest()"
            [throttleTime]="1000"
            data-testid="agreement-form-step3-offer-or-send-button"
          >
            {{ isNewAgreement ? 'Offer' : 'Send' }}
          </mable-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
